import { Link } from "react-router-dom";
import { Logo } from "@/components/Layout";
import Footer from "@/components/Footer";

export function LegalShell({ title, updated, children }) {
  return (
    <div className="min-h-screen grain flex flex-col">
      <header className="border-b border-zinc-200 bg-white/70 backdrop-blur-xl sticky top-0 z-20">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <Link to="/" className="text-sm text-zinc-500 hover:text-black transition-colors">← Home</Link>
        </div>
      </header>
      <main className="flex-1 max-w-3xl mx-auto px-6 py-14 relative z-10">
        <h1 className="font-display font-black text-4xl tracking-tighter mb-2">{title}</h1>
        <p className="text-xs font-mono text-zinc-400 mb-10">LAST UPDATED · {updated}</p>
        <div className="prose-legal space-y-6 text-[15px] leading-relaxed text-zinc-700 [&_h2]:font-display [&_h2]:font-bold [&_h2]:text-xl [&_h2]:tracking-tight [&_h2]:text-black [&_h2]:mt-8 [&_h2]:mb-2">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function Terms() {
  return (
    <LegalShell title="Terms of Use" updated="JUNE 2026">
      <p>Welcome to SelectFlow, a secure election and decision platform operated by I-Assist Pro ("we", "us"). By creating an organisation or casting a vote, you agree to these Terms of Use.</p>
      <h2>1. Accounts & organisations</h2>
      <p>You are responsible for the accuracy of information you provide and for all activity under your organisation. Administrators must keep credentials confidential and only invite people authorised to manage elections.</p>
      <h2>2. Acceptable use</h2>
      <p>You may not use SelectFlow to run fraudulent ballots, harvest personal data unlawfully, send unsolicited messages, or interfere with the integrity of any election. Voting links are unique and single-use; sharing or attempting to reuse them is prohibited.</p>
      <h2>3. Elections & anonymity</h2>
      <p>Ballots are recorded without any voter identifier and cannot be traced back to individual voters. As the organiser, you are responsible for the lawful conduct of your elections and for informing voters how their contact details are used.</p>
      <h2>4. Plans & payments</h2>
      <p>Paid plans and per-election purchases are billed through our payment processor. Fees are non-refundable except where required by law. Plan limits (voter counts, active elections) are enforced automatically.</p>
      <h2>5. Availability & liability</h2>
      <p>SelectFlow is provided "as is". We work hard to keep the service secure and available but do not guarantee uninterrupted access. To the maximum extent permitted by law, our liability is limited to the fees you paid in the preceding month.</p>
      <h2>6. Contact</h2>
      <p>Questions about these terms can be sent to <a href="mailto:info@iassistpro.com" className="text-[#1F6FE5]">info@iassistpro.com</a>.</p>
    </LegalShell>
  );
}

export function Privacy() {
  return (
    <LegalShell title="Privacy Policy" updated="JUNE 2026">
      <p>This policy explains how I-Assist Pro handles personal data within SelectFlow.</p>
      <h2>1. Data we process</h2>
      <p>For administrators: name, email and organisation details. For voters: the name, email and/or phone number uploaded by the organiser so we can deliver a unique voting link. We also store hashed voting tokens — never the raw token.</p>
      <h2>2. Ballot anonymity</h2>
      <p>Cast ballots contain no voter identifier and their timestamps are rounded so they cannot be correlated with individual voters. We record only that a voter has voted, not how they voted.</p>
      <h2>3. How we use data</h2>
      <p>Contact details are used solely to send invitations and reminders for the specific election, via email (Resend) and SMS (Hubtel). We do not sell personal data.</p>
      <h2>4. Retention</h2>
      <p>Election data is retained for the organiser's account until they delete an election or close their account. Organisers may remove voters who have not yet voted at any time.</p>
      <h2>5. Security</h2>
      <p>Access is scoped per organisation, admin endpoints require authentication, and voting tokens are cryptographically random, hashed at rest and single-use.</p>
      <h2>6. Contact</h2>
      <p>For data requests, contact <a href="mailto:info@iassistpro.com" className="text-[#1F6FE5]">info@iassistpro.com</a>.</p>
    </LegalShell>
  );
}
